import styled from 'styled-components'
import Flex from '../Flex'
import Icon from '../Icon'
import Text from '../Text'
import { IconVariant, iconVariant } from 'utils/icon'
import { HexToRgba, ThemeColor, colors } from 'utils/colors'
import Box from 'components/Box'

type BorderOption = 'top' | 'bottom'

interface Props {
  variant: IconVariant
  message: string
  border?: BorderOption
  onClose?: () => void
  subTitle?: string
}

const Banner = ({ variant, message, border, onClose, subTitle }: Props) => {
  const selectedVariant = iconVariant[variant]
  return (
    <WhiteBg>
      <Container color={selectedVariant.color} border={border}>
        <Flex gap="12px">
          <Icon icon={selectedVariant.icon} color={selectedVariant.color} />
          <Box>
            <Text color={selectedVariant.color}>{message}</Text>
            {subTitle && <Text color={selectedVariant.color}>{subTitle}</Text>}
          </Box>
        </Flex>
        {onClose && <Icon icon={['far', 'times']} color={selectedVariant.color} onClick={onClose} />}
      </Container>
    </WhiteBg>
  )
}

const Container = styled.div<{ border?: BorderOption; color: ThemeColor }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: white;
  background-color: ${(p) => HexToRgba(colors[p.color], 0.1)};
  ${({ border, color }) =>
    border
      ? `${
          border === 'top'
            ? `border-top: 1px solid ${HexToRgba(colors[color], 0.7)}`
            : `border-bottom: 1px solid ${HexToRgba(colors[color], 0.7)}`
        }`
      : ''}
`

const WhiteBg = styled.div`
  background: white;
`

export default Banner
